import { render } from "./add.vue?vue&type=template&id=3958698f"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=3958698f&lang=less"

import exportComponent from "/Users/luguo/Library/Containers/com.tencent.xinWeChat/Data/Documents/xwechat_files/wxid_mb9a46n46pgc12_85b3/msg/file/2026-03/management-2.2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__